<template>
  <img
    v-quick-title="content"
    class="ml10 help-icon"
    src="@/assets/img/help-bold-blue.png"
    alt=""
    @click="displayHelp"
  >
</template>

<script>
/**
 * Help button. Hovering or clicking the button displays help
 */

import { calert } from '@/utils/main';

export default {
  name: 'HelperButton',
  props: {
    content: {
      type: String,
      required: true,
    },
  },
  methods: {
    displayHelp() {
      calert(this.content, [
        { title: this.$t('message.OK') },
      ]);
    },
  },
};
</script>

<style lang="scss">
.help-icon {
  width: 20px;
  height: 20px;
  cursor: pointer;
}
</style>
